var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "gallery-main" },
    [
      _vm.mediaItems
        ? _c("media-list", {
            attrs: {
              "server-items": _vm.mediaItems,
              categories: _vm.categories,
              options: _vm.options,
              "limit-overwrite": Number(_vm.options.MediaItemsPerLoadMore),
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }